import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import { CDBTable, CDBTableHeader, CDBTableBody, CDBSpinner } from "cdbreact";
import {
  findAllCarsByCompany,
  findAllCarsByCompanyPage,
  deleteCar,
  findCarLicensePlateLikeOrModel,
} from "../../../services/CarService";
import { toast } from "react-toastify";
import PaginationBootstrap from "../../../components/PaginationBootstrap";
import EditarVeiculo from "./EditarVeiculo";
import NovoVeiculo from "./NovoVeiculo";

export const Veiculos = () => {
  const [vehicles, setVehicles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState();
  const [toggled, setToggled] = useState(false);
  const filterLicensePlate = useRef("");

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    setIsLoading(true);
    listVehicles();
  }, []);

  function removeVehicle(id) {
    const execute = window.confirm(
      "Tem certeza que deseja excluir este veículo?"
    );

    if (execute) {
      deleteCar(id)
        .then((response) => {
          toast.success(response);
          listVehicles();
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status == 422)
            toast.warn(error.response.data);
          else toast.error("Não foi possivel exluir este veículo");
        });
    }
  }

  function listVehicles() {
    findAllCarsByCompany()
      .then((response) => {
        setVehicles(response.data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }

  function listVehiclesByPage(page) {
    findAllCarsByCompanyPage(page)
      .then((response) => {
        setVehicles(response.data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }

  function filterCarLicensePlateLikeOrModel() {
    if (filterLicensePlate.current.value) {
      setIsLoading(true);
      findCarLicensePlateLikeOrModel(filterLicensePlate.current.value)
        .then((response) => {
          setVehicles(response.data);
          setPageInfo(response.pageInfo);
          setIsLoading(false);
        })
        .catch((error) => setIsLoading(false));
    }
  }

  function handleSidebarToggle() {
    const isMobile = window.innerWidth <= 720;
    if (isMobile) {
      setToggled(true);
    }
  }

  function handleClickClearFilter() {
    listVehicles();
    filterLicensePlate.current.value = "";
  }

  return (
    <div className="d-flex">
      <div>
        <Sidebar toggled={toggled} />
      </div>
      <div className="main-content-wrapper">
        <Navbar toggled={toggled} setToggled={setToggled} />
        <div>
          <div
            style={{
              padding: "20px 5%",
            }}
          >
            <div>
              <div className="mt-3">
                <div className="d-flex justify-content-between">
                  <h3 className="fw-bold text-dark">Veículos</h3>
                </div>

                <div className="d-flex mt-3 mb-1">
                  <NovoVeiculo listVehicles={listVehicles} />
                  <div className="vertical-line me-1"></div>
                  <div>
                    <button
                      className="btn btn-primary fw-bold d-flex align-items-center"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseExample"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                    >
                      <i className="fa fa-filter me-2"></i>
                      Filtrar
                    </button>
                  </div>
                </div>

                <div className="mt-3 mb-3">
                  <div className="collapse" id="collapseExample">
                    <div className="card card-body">
                      <div>
                        <input
                          ref={filterLicensePlate}
                          className="form-control"
                          placeholder="Filtrar por placa, fabricante ou modelo do veículo"
                        />
                      </div>
                      <div className="mt-3">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={filterCarLicensePlateLikeOrModel}
                          disabled={!filterLicensePlate}
                        >
                          <i
                            className="fa fa-search me-2"
                            aria-hidden="true"
                          ></i>
                          Pesquisar
                        </button>

                        <button
                          className="btn mx-3"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseExample"
                          onClick={handleClickClearFilter}
                        >
                          <i className="fa fa-times me-2"></i>
                          Limpar filtro
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {isLoading ? (
                  <div className="d-flex justify-content-center p-3">
                    <CDBSpinner dark />
                  </div>
                ) : (
                  <>
                    <CDBTable className="alcon-table" responsiveSm borderless>
                      <thead>
                        <tr>
                          <th>Placa</th>
                          <th>Veículo</th> {/* Agrupamos Fabricante e Modelo para ganhar espaço */}
                          <th>Cor</th>
                          <th>Dono / Cliente</th>
                          <th className="text-end px-4">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vehicles && vehicles.map((car) => (
                          <tr key={car.id}>
                            {/* Placa com estilo de 'Etiqueta' para leitura rápida */}
                            <td>
                              <span className="badge bg-primary text-white px-3 py-2 rounded-2 shadow-sm fw-bold" style={{ letterSpacing: '1px', fontSize: '0.85rem' }}>
                                {car.licensePlate.toUpperCase()}
                              </span>
                            </td>

                            {/* Fabricante e Modelo juntos */}
                            <td>
                              <div className="fw-bold text-dark">{car.model}</div>
                              <div className="text-muted small text-uppercase">{car.brand.replace("_", " ")}</div>
                            </td>

                            {/* Cor com um detalhe visual se quiser (opcional) */}
                            <td className="text-muted">
                              <i className="fas fa-palette me-2 small"></i>
                              {car.color}
                            </td>

                            {/* Cliente / Dono */}
                            <td className="fw-medium">
                              <i className="fas fa-user me-2 text-secondary small"></i>
                              {car.customerName}
                            </td>

                            {/* Ações usando o seu novo .btn-3-dots */}
                            <td className="text-end px-3">
                              <div className="dropdown">
                                <button
                                  className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  data-bs-display="static"
                                >
                                  <i className="fas fa-ellipsis-v"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                                  <li>
                                    <EditarVeiculo
                                      listVehicles={listVehicles}
                                      vehicle={car}
                                    />
                                  </li>
                                  <li><hr className="dropdown-divider" /></li>
                                  <li>
                                    <button
                                      onClick={() => removeVehicle(car.id)}
                                      className="dropdown-item py-2 d-flex align-items-center text-danger"
                                    >
                                      Excluir Veículo
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CDBTable>
                    <div>
                      {vehicles.length > 0 ? (
                        <PaginationBootstrap
                          pageInfo={pageInfo}
                          goToPage={listVehiclesByPage}
                        />
                      ) : (
                        <>Nenhum veículo cadastrado.</>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Veiculos;
